import { render, staticRenderFns } from "./RadioGroupItem.vue?vue&type=template&id=2fa7b0de&scoped=true"
import script from "./RadioGroupItem.vue?vue&type=script&lang=ts"
export * from "./RadioGroupItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa7b0de",
  null
  
)

export default component.exports